import SEOHead from "./SEO/SEOHead";

/**
 * Re-export SEOHead as default SEO component for backwards compatibility.
 */
export default SEOHead;
export { SEOHead };
